import { useState, useEffect, useMemo } from 'react';
import api from 'utils/api';
import { useFavorites } from '../components/Favorite';

const transformGame = (res) => ({
  id: res.uuid,
  name: res.name,
  code: res?.code,
  description: res.description,
  banner: res.banner,
  icon: res.icon,
  logo: res.logo,
  thumbnail_url: res.thumbnail_url,
  url: res.url,
  version: res.version,
  genre_label: (res.genres || []).map((x) => x.name).join(', '),
  is_playable: res.status === 'ACTIVE' && res.game_status === 'PUBLISHED',
  is_undermaintenance: res?.game_status === 'MAINTENANCE',
});

const useGamesList = (filter) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [list, setList] = useState([]);
  const [favorites] = useFavorites();
  useEffect(() => {
    setIsLoading(true);
    api
      .get(
        '/subscriber_games/v1/game?sort[status]=asc&sort[priority]=desc&sort[name]=asc&is_hidden=0&platforms[]=web',
        {
          session: true,
        }
      )
      .then((res) => {
        setIsLoading(false);
        if (res?.error) {
          setError(res?.data || { message: 'Unable to load games.' });
          return;
        }
        const games = (res.data || []).map(transformGame);
        setList(games);
      });
  }, [setList, setIsLoading]);
  const filteredList = useMemo(() => {
    let newList = list.filter((row) =>
      filter.keyword
        ? row.name.toLowerCase().indexOf(filter.keyword) > -1
        : true
    );
    if (filter?.favorite) {
      newList = newList.filter((x) => favorites.indexOf(x?.id) > -1);
    }
    return newList;
  }, [list, filter, favorites]);
  return [isLoading, filteredList, error];
};

export default useGamesList;
